import Application from "../../Application";
import GetAllOrganisationsInteractor from "../../organisations/interactors/GetAllOrganisationsInteractor";
import LegalViewsPresenter, {
  ILegalViewsPresenter
} from "../presenter/LegalViewsPresenter";
import GetAllLegalViewsInteractor from "./GetAllLegalViewsInteractor";
import GetAllLegalViewTypesInteractor from "./GetAllLegalViewTypesInteractor";

export default class ShowLegalViewInteractor {
  private application: Application;
  private output?: ILegalViewsPresenter;
  private getAllLegalViewsInteractor: GetAllLegalViewsInteractor;
  private getAllLegalViewTypesInteractor: GetAllLegalViewTypesInteractor;
  private getAllOrganisationsInteractor: GetAllOrganisationsInteractor;

  constructor({
    application,
    getAllOrganisations,
    getAllLegalViewTypes,
    getAllLegalViews
  }) {
    this.application = application;
    this.getAllOrganisationsInteractor = getAllOrganisations;
    this.getAllLegalViewTypesInteractor = getAllLegalViewTypes;
    this.getAllLegalViewsInteractor = getAllLegalViews;
  }
  private async getAllLegalViewTypes() {
    return this.getAllLegalViewTypesInteractor.execute();
  }
  private async getAllOrganisations() {
    return this.getAllOrganisationsInteractor.execute();
  }

  private async getReferenceLists() {
    return Promise.all([
      this.getAllLegalViewTypes(),
      this.getAllOrganisations()
    ]);
  }
  execute() {
    this.output = LegalViewsPresenter({
      application: this.application,

      initialState: { legalViews: [], organisations: [], legalViewTypes: [] }
    });
    this.getReferenceLists()
      .then(([legalViewTypes, organisations]) =>
        this.output?.loadReferenceValues(legalViewTypes, organisations)
      )
      .then(() => this.getAllLegalViewsInteractor.execute())
      .then(this.output.loadAllLegalViews);
    return this.output;
  }
}
